<template>
    <v-container fluid class="pa-0 px-3">
        <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0;">
            <h2 class="pt-3 pb-2" style="letter-spacing:normal;">My Staff</h2>
        </div>
        <app-my-staff />
    </v-container>
</template>

<script>
import MyStaffForm from '../../sscomponents/attendance/MyStaffForm.vue';

export default {
    components: {
        'app-my-staff': MyStaffForm,
    },
};
</script>
